



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { DepartmentManager } from '@/models/admin/department';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getManagerListHeaders } from '@/views/admin/department/department';
import {departmentService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class ManagerListPage extends Base {
  public pagedManagers: DepartmentManager[] = [];
  public headers: VHeaders[] = getManagerListHeaders(this);
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number = 0;
  public actions: any[] = [];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('departments.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteManager();
    },
  };
  public departmentId: string = '';
  public managerToDelete: DepartmentManager = {
    id: '',
    email: '',
    approvalLimit: 0,
    isNoLimit: false,
  };
  public preventPaginationCall: boolean = false;
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'departments.managerGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: DepartmentManager, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.departments',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'addManager') {
      this.$router.push({
        name: 'admin.departments.managers.add',
        params: { id: this.departmentId },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('departments.btnAddManager'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('departments.btnAddManager'),
      click: 'addManager',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'departments');
    
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = Number(this.userSession.storeId);
    }
    if (this.$route.params.id) {
      this.departmentId = this.$route.params.id;
      this.getManagers();
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
  }
  public async getManagers(): Promise<void> {
    try {
      this.loading = true;
      const managers = await departmentService.getManagersAsync(
        Number(this.storeId),
        this.departmentId
      );
      this.pagedManagers = managers.results;
      this.pagination.totalItems = managers.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public confirmDelete(item: DepartmentManager): void {
    this.deleteDialog.model = true;
    this.managerToDelete = item;
  }
  public async deleteManager(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await departmentService.deleteManagerAsync(
        this.departmentId,
        this.managerToDelete.id,
        this.storeId
      );
      this.preventPaginationCall = true;
      this.showAlert(true, this.$t('departments.alertDeleteDepartmentManager'));
      this.getManagers();
    } finally {
      this.deleteDialog.model = false;
      this.deleteDialog.loading = false;
    }
  }
}
